import React from 'react';
import css from './styles.module.scss';
import { CreatorCard1 } from '~/features/creators-list/components/creater-new-card';
import { CreatorListItem } from '~/models/creatorsList.dto';

interface CreatorRowProps {
    data: CreatorListItem;
}

export const CreatorRow: React.FC<CreatorRowProps> = ({ data }) => {
    return (
        <>
            <div className={css.module}>
                <CreatorCard1 data={data} />
                {/* <CreatorActions creatorId={data.projectId} /> */}
            </div>
        </>
    );
};
